import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IIceCatReportHaveNotUpdatedRequest } from '../models/models'

export class GetIceCatReportNotComingApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/icecat/GetIceCatReportNotComing',
      requesterInfo,
    })
  }

  public async getIceCatReportNotComing(request: IIceCatReportHaveNotUpdatedRequest): Promise<any[]> {
    return await this.postAsync<any[]>(request)
  }
}
